export function formatDateRange(startDateStr?: string, endDateStr?: string): string {
  if (!startDateStr) {
    return '';
  }
  const startDate = new Date(startDateStr);
  const endDate = endDateStr ? new Date(endDateStr) : startDate;

  const formatterDayMonthYear = new Intl.DateTimeFormat('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });
  const formatterDayMonth = new Intl.DateTimeFormat('it-IT', { day: 'numeric', month: 'long' });
  const formatterDay = new Intl.DateTimeFormat('it-IT', { day: 'numeric' });

  if (!endDateStr || startDate.getTime() === endDate.getTime()) {
    return formatterDayMonthYear.format(startDate);
  }

  if (startDate.getFullYear() === endDate.getFullYear()) {
    if (startDate.getMonth() === endDate.getMonth()) {
      return `${formatterDay.format(startDate)}-${formatterDayMonthYear.format(endDate)}`;
    }
    return `${formatterDayMonth.format(startDate)} - ${formatterDayMonthYear.format(endDate)}`;
  }

  return `${formatterDayMonthYear.format(startDate)} - ${formatterDayMonthYear.format(endDate)}`;
}
